var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDriverMap(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12183_6518)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 9.72391L11.7251 9.56128L10.6386 8.95617L10.9444 7.2231L10.7593 4.58295L10.542 4.41943L8.00009 5.33679L7.77344 5.70055V14.9329L8.00009 15.349L12.0001 13.9054L12.2161 13.6371V9.47864L12.0001 9.72391Z",
    fill: "#6BBEF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25574 4.70752H5.99984L3.74902 7.10783V13.6913L3.99984 13.9056L7.9998 15.3492V5.33696L6.25574 4.70752Z",
    fill: "#90D8F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.89944 6.82558L2 4.70752H1.74409L0.221062 5.25718C0.0884687 5.30501 0 5.43152 0 5.57327V14.872C0 15.1044 0.229 15.2665 0.446406 15.1881L4 13.9056V7.10783L3.89944 6.82558Z",
    fill: "#6BBEF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.91522 14.346V4.70752H1.74409L0.221062 5.25718C0.0884687 5.30501 0 5.43152 0 5.57327V14.872C0 15.1044 0.229 15.2665 0.446406 15.1881L2.03909 14.6133C1.96444 14.5501 1.91522 14.4557 1.91522 14.346Z",
    fill: "#6BBEF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.00008 0.650391C1.72489 0.650391 0.510764 3.34859 2.0117 5.06909L3.65161 6.94885C3.8363 7.16054 4.16386 7.16054 4.34851 6.94885L5.98842 5.06909C7.48939 3.34859 6.27523 0.650391 4.00008 0.650391ZM4.00008 4.79664C3.18845 4.79664 2.53051 4.13459 2.53051 3.3179C2.53051 2.50123 3.18845 1.83918 4.00008 1.83918C4.8117 1.83918 5.46964 2.50123 5.46964 3.3179C5.46961 4.13459 4.81167 4.79664 4.00008 4.79664Z",
    fill: "#FD4438"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 3.89307L10.5418 4.4193C10.6019 4.81268 10.5844 5.30748 10.169 5.45813C9.47689 5.70919 9.41233 6.47853 9.99995 6.55953C10.5876 6.64051 10.8934 6.89157 10.7002 7.3451C10.5071 7.79861 9.84711 9.06239 10.99 9.62099C11.3058 9.77532 11.6523 9.7818 12 9.72381L12.1395 9.49055V4.08765L11.9999 3.89307Z",
    fill: "#8EDA70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3729 12.2981C13.4822 11.4991 14.9416 10.9268 14.609 9.7239C14.2763 8.52102 12.2482 9.44206 12.2482 9.44206L12 9.7239V13.9054L14.8078 14.9187C16.0583 14.084 15.2636 13.0972 14.3729 12.2981Z",
    fill: "#90D8F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5536 15.1878C15.771 15.2662 16 15.1041 16 14.8717V5.57297C16 5.43121 15.9115 5.30471 15.7789 5.25688L12 3.89307V9.72381C12.9106 9.57196 13.8294 8.97736 14.2254 9.43452C14.7727 10.0662 14.4186 10.5683 14.2254 10.7303C14.0323 10.8923 13.3079 12.0908 14.2898 12.6577C15.1765 13.1697 15.5812 14.0235 14.8078 14.9186L15.5536 15.1878Z",
    fill: "#78BA5D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12183_6518"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriverMap);
export default __webpack_public_path__ + "static/media/driver-map.e95b9b817afee53fd09893e0bf564bec.svg";
export { ForwardRef as ReactComponent };